import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getEmpresa } from '../../../services/empresaService';
import { headerEmpresa } from '../../helpers/headerEmpresa';


async function ProdutoPdf(produtos) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const empresa = await getEmpresa();

  const reportTitle = {
    text: 'Relatório de Produtos',
    fontSize: 15,
    alignment: 'center',
    bold: true,
    margin: [0, 10, 0, 20]
  };

  const dados = produtos.map(produto => ([
    { text: produto.COD_PRODUTO, fontSize: 7 },
    { text: produto.DESCRICAO, fontSize: 7 },
    { text: produto.NCM, fontSize: 7 },
    { text: produto.ST, fontSize: 7, alignment: 'center' },
    { text: Number(produto.ESTOQUE).toFixed(3), fontSize: 7, alignment: 'right' },
    { text: 'R$ ' + Number(produto.COMPRA).toFixed(2), fontSize: 7, alignment: 'right' },
    { text: 'R$ ' + Number(produto.VENDA).toFixed(2), fontSize: 7, alignment: 'right' }
  ]));

  const details = {
    table: {
      headerRows: 1,
      widths: [55, 200, 50, 40, 40, 40, 35],
      body: [
        [
          { text: 'Código', style: 'tableHeader' },
          { text: 'Nome', style: 'tableHeader' },
          { text: 'NCM', style: 'tableHeader' },
          { text: 'ST', style: 'tableHeader' },
          { text: 'Estoque', style: 'tableHeader' },
          { text: 'Compra', style: 'tableHeader' },
          { text: 'Venda', style: 'tableHeader' }
        ],
        ...dados
      ]
    },
    layout: 'lightHorizontalLines'
  };

  const docDefinitions = {
    pageSize: 'A4',
    pageMargins: [15, 60, 15, 40],

    header: headerEmpresa(empresa),

    content: [
      reportTitle,
      details
    ],

    footer: (currentPage, pageCount) => ({
      text: `${currentPage} / ${pageCount}`,
      alignment: 'right',
      fontSize: 9,
      margin: [0, 10, 20, 0]
    })
  };

  pdfMake.createPdf(docDefinitions).open();
}

export default ProdutoPdf;